export default [
    {
        "fa": "fas fa-chart-line",
        "value": "RadNet Investor Day 2025",
        "linkTo": "https://www.radnet.com/investor-day?utm_source=rad_link&utm_medium=radnet_family_websites&utm_campaign=investor_day"
    },
    {
        "fa": "fas fa-microphone",
        "value": "Dr. Howard Berger iHeartRadio Interview",
        "linkTo": "https://kfiam640.iheart.com/featured/ceos-you-should-know-la/content/2025-08-ceos-you-should-know-howard-berger-ceo-founder-of-radnet/"
    },
    {
        "fa": "fas fa-microphone",
        "value": "Your Body Podcast",
        "linkTo": "https://www.yourbodyshow.com/?utm_source=rad_link&utm_medium=radnet_family_websites&utm_campaign=your_body_show"
    },
    {
        "fa": "fas fa-globe",
        "value": "MammogramNow",
        "linkTo": "https://breastlink.com/services/mammogramnow?utm_source=rad_link&utm_medium=radnet_family_websites&utm_campaign=mammo_now"
    },
    {
        "fa": "fas fa-heartbeat",
        "value": "RadNet Cardiac Program",
        "linkTo": "https://www.radnet.com/cardiac-imaging?utm_source=rad_link&utm_medium=radnet_family_websites&utm_campaign=radnet_cardiac"
    },
    {
        "fa": "fas fa-user-md",
        "value": "RadNet Prostate Screening",
        "linkTo": "https://prostate.radnet.com/?utm_source=rad_link&utm_medium=radnet_family_websites&utm_campaign=radnet_prostate"
    },
    {
        "fa": "fas fa-lungs",
        "value": "RadNet Lung Cancer Screening",
        "linkTo": "https://radnetimaging.com/low-dose-lung-ct-scan/?utm_source=rad_link&utm_medium=radnet_family_websites&utm_campaign=radnet_lungn/"
    },
    {
        "fa": "fas fa-hand-holding-medical",
        "value": "Your CHOICE in Imaging",
        "linkTo": "https://choice.radnet.com/"
    },
    {
        "fa": "fa fa-briefcase",
        "value": "RadNet Careers",
        "linkTo": "https://careers.radnet.com/careers-home?utm_source=rad_link&utm_medium=radnet_family_websites&utm_campaign=radnet_careers/careers-home"
    },
    {
        "fa": "fas fa-female",
        "value": "#MaddyTheMammoCoach",
        "linkTo": "https://breastlink.com/services/mobile-mammography?utm_source=rad_link&utm_medium=radnet_family_websites&utm_campaign=maddy"
    },
    {
        "fa": "fas fa-play-circle",
        "value": "RadNet TV",
        "linkTo": "https://www.radnet.tv/?utm_source=rad_link&utm_medium=radnet_family_websites&utm_campaign=radnet_tv"
    },
    {
        "fa": "fa-solid fa-x-ray",
        "value": "X-Ray Hours & Live Wait Times",
        "linkTo": "https://xrayhours.com/?utm_source=rad_link&utm_medium=radnet_family_websites&utm_campaign=xray_hours"
    },
    {
        "fa": "fas fa-globe",
        "value": "EastXRayHours.com",
        "linkTo": "https://eastxrayhours.com/?utm_source=rad_link&utm_medium=radnet_family_websites&utm_campaign=east_xray"
    },
    {
        "fa": "fa-solid fa-phone",
        "value": "Tulsa Oklahoma Contact Center",
        "linkTo": "https://radnettulsa.com/"
    },
    {
        "fa": "fas fa-user-md",
        "value": "Beverly Radiology Medical Group",
        "linkTo": "https://www.beverlyradiologymedicalgroup.com/"
    },
    {
        "fa": "fa-solid fa-puzzle-piece",
        "value": "Cancer Research Collaboration",
        "linkTo": "https://www.cancerresearchcollaboration.org/"
    }
]